<template>
    <el-dialog :visible.sync="showFeedDialog" :close-on-click-modal="false" :modal="false" width="743px"
        class="deletion_box" @close="$emit('closed', false)" append-to-body>
        <template #title>
            <div class="custom-title">
                <img src="@comm/images/document-conversion/home/title_icon.svg" alt="关于开放平台服务下线的通知">
                <span>关于开放平台服务下线的通知</span>
            </div>
        </template>
        <div class="deletion_content">
            <h4 style="margin-top: 0;">尊敬的合作伙伴与开发者：</h4>
            <p>感谢您一直以来对我们开放平台服务的关注与支持。因业务调整和战略规划需要，我们将对现有开放平台服务进行逐步下线。为确保您的业务平稳过渡，现将相关安排通知如下:</p>
            <h4>一、下线时间安排</h4>
            <p>1.接口停止新增：自即日起，开放平台将不再接受新的接口调用申请。</p>
            <p>2.服务停止时间：现有服务预计于2026年4月20日正式终止。</p>
            <p>3.用户数据清理和保留期限：服务正式终止后，平台将在30日内继续保留所有用户数据(即注册申请服务时提供的企业基本信息、营业执照附件、申请人信息等)，30日后该数据将被彻底删除。</p>
            <p>4.关于费用事项:该平台一直为用户提供免费试用，不涉及任何收费和退费事项。</p>
            <h4>二、下线影响范围</h4>
            <p>本次下线将涉及以下相关功能与服务:</p>
            <p>所有开放API接口调用服务</p>
            <p>开放平台相关功能</p>
            <p>第三方应用授权</p>
            <h4>三、联系我们</h4>
            <p>如有任何疑问或需要协助，请通过以下方式联系：服务热线:400-677-5005(工作日9:00-18:00)、在线客服:通过官网右下角“联系我们”接入</p>
            <h4>对于本次服务调整给您带来的不便，我们深表歉意。再次感谢您长久以来的信任与陪伴，我们将继续致力于提供更优质的产品与服务。</h4>
            <h4>特此通知。</h4>
            <h4>北京数科网维技术有限责任公司</h4>
            <p>2026年3月18日</p>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="showFeedDialog = false" size="mini" class="mini_btn">我知道了</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        showFeedDialog: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {

        };
    },
    watch: {

    },
    computed: {

    },
    methods: {
    }
};
</script>
<style lang="scss">
.deletion_box .el-dialog .el-dialog__body {
    padding-bottom: 12px !important;
}
.deletion_box .el-dialog .el-dialog__header {
    margin-bottom: 0 !important;
    border-bottom: none !important;
    padding-bottom: 12px !important;
}
</style>
<style lang="scss" scoped>
.custom-title{
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(13, 13, 13, 1) !important;
    img{
        margin-right: 8px;
    }
}
.deletion_content {
    font-size: 13px;
    color: rgba(13, 13, 13, 1);
    line-height: 20px;
    max-height: 560px;
    overflow-y: auto;
    h4 {
        margin-top: 20px;
    }
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    .el-button--primary {
            background: rgba(31, 105, 224, 1) !important;
            border-radius: 6px !important;
            border-color: rgba(31, 105, 224, 1) !important;
        }
}
</style>


// WEBPACK FOOTER //
// src/comm/components/document-conversion/deletionNotice/index.vue